// src/components/ActivityNameAutocomplete.js

import { Combobox } from '@headlessui/react';
import { useEffect, useState } from 'react';
import { useApi } from '../apiClient';

export default function ActivityNameAutocomplete({
  value,
  onChange,
  placeholder = "กิจกรรม เช่น ประชุม, อ่านหนังสือ, เดินเล่น"
}) {
  const api = useApi();
  const [allActivities, setAllActivities] = useState([]);
  const [query, setQuery] = useState('');

  useEffect(() => {
    api.activities.list({ limit: 1000 })
      .then(data => {
        const uniq = [...new Set(
          (data || []).map(d => (d.activity ?? "").trim()).filter(Boolean)
        )];
        setAllActivities(uniq);
      })
      .catch(() => {});
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // filter suggestion ตาม keyword
  const filtered =
    query === ''
      ? allActivities
      : allActivities.filter(a =>
          a.toLowerCase().includes(query.toLowerCase())
        );

  return (
    <Combobox value={value} onChange={onChange}>
      <div className="relative mb-4">
        <Combobox.Input
          className="w-full border rounded-xl px-3 py-2"
          displayValue={v => v}
          placeholder={placeholder}
          onChange={e => {
            setQuery(e.target.value);
            onChange(e.target.value);
          }}
        />
        {filtered.length > 0 && (
          <Combobox.Options className="absolute z-10 bg-white border rounded shadow max-h-40 w-full overflow-auto">
            {filtered.map((a, i) => (
              <Combobox.Option
                key={i}
                value={a}
                className={({ active }) =>
                  `cursor-pointer px-4 py-2 ${active ? "bg-indigo-100" : ""}`
                }
              >
                {a}
              </Combobox.Option>
            ))}
          </Combobox.Options>
        )}
      </div>
    </Combobox>
  );
}